export default __webpack_public_path__ + "9ddb2524cb5f1c7ae8b2dfe8023b7b77.png";